import { Store as ReduxStore } from 'redux';

import { BrowserProxy } from '../browserProxy';
import { getDocumentId, getDocumentName, getPageCount, getPageId, getPageName, getPageNumber, getTenantId, getTenantName, getMailToName, getMailToAddress, getBreadcrumb } from '../settings';

import METADATA_CHANGE from '../meta/actions/CHANGE';
import isOutOfDate from './isOutOfDate';
import selectors from './selectors';

/* tslint:disable */
declare interface WebpackRequire extends NodeRequire {
  ensure(a: any[], b: (r: any) => any): any;
}
declare var require: WebpackRequire;
declare global {
  interface Console {
    timeStamp(name: string): void;
  }
}
/* tslint:enable */

// HACK: here for workaround in selection, selection implementation requires to dispatch actions from multiple element event handlers.
export const hack: any = { store: null };

const warnElementCount = 10000;

function registerProxy(proxy: BrowserProxy) {
  const key = 'LiasNoteService';
  const keyReady = 'LiasNoteServiceReady';
  global[key] = proxy;
  /* tslint:disable */
  const proxyCallback: Array<(proxy: BrowserProxy) => void> = global[keyReady];
  /* tslint:enable */
  if (proxyCallback) {
    proxyCallback.forEach((x) => x(proxy));
  }
}
function subscribeProxy(proxy: BrowserProxy, store: ReduxStore<any>) {
  let wasVisible = false;
  store.subscribe(() => {
    // TODO: middleware
    const state = store.getState();
    const v = selectors.visible(state);
    if (wasVisible !== v) {
      if (v) {
        proxy.emit('shown');
      } else {
        proxy.emit('hidden');
      }
      wasVisible = v;
    }
  });
}
function createProxy(store: ReduxStore<any>) {
  const proxy = new BrowserProxy(
    () => selectors.visible(store.getState()),
    (action) => store.dispatch(action),
  );
  registerProxy(proxy);
  subscribeProxy(proxy, store);
  return proxy;
}

(require as any).ensure([], async () => {
  const { Store } = require('../store/Store');
  const { DefaultPlaceHolder, RenderApp, RenderOutOfDate } = require('./render');

  // tslint:disable-next-line
  // await ready;
  if (isOutOfDate()) {
    RenderOutOfDate();
  } else {
    const store = hack.store = Store.create();

    const proxy = createProxy(store);      
    store.dispatch(METADATA_CHANGE({
      docId: getDocumentId(),
      docName: getDocumentName(),
      pageCount: getPageCount(),
      pageId: getPageId(),
      pageName: getPageName(),
      pageNumber: getPageNumber(),
      pageUrl: window.location.href,
      tenantId: getTenantId(),
      tenantName: getTenantName(),
      breadcrumb: getBreadcrumb(),
      mailToName: getMailToName(),
      mailToAddress: getMailToAddress(),  
    })); 
    
    const loadMaterialIcons = selectors.loadMaterialIcons(store.getState()); 
    if (loadMaterialIcons) {
      await import (`../theme/materialicons.css`);
      
    } else {
      // tslint:disable-next-line:no-console
      console.log(`[NoteService] Skipping Material Icons`);
    }
    
    const elCount = document.querySelectorAll('*').length;
    if (elCount > warnElementCount) {
      // tslint:disable-next-line
      console.warn(`[NoteService] Page contains ${elCount.toLocaleString()} elements. May result in reduced performance of note highlights.`);
    }

    DefaultPlaceHolder();
    await RenderApp(store);

    proxy.emit('loaded');

  }
});



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/browser/launch.tsx